import { render, staticRenderFns } from "./ProjectCrmOverview.vue?vue&type=template&id=5b2ea3d6&"
import script from "./ProjectCrmOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectCrmOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports